module.exports = __webpack_public_path__ + "img/og-lp-agence-communication.9f37686.jpg";